import withAemIntegration from "../../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import { lazy } from "@loadable/component";
import ComponentWrapper from "../../component-wrapper";
const Component = lazy(
  () => import("@lexus.com/ui/dist/modules/FormBuilder"),
  {
    resolveComponent: (comp) => comp.FormContext,
  }
);

const FormBuilderContainerEditConfig = {
  emptyLabel: "Form Builder Container",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {
  return {
    ...props,
    services: props.apiInfo?.services,
    apis: props.apiInfo?.staticFormData?.reduce(
      (acc, value) => ({ ...acc, [value.name]: value.value }),
      {}
    ),
    headline: props.heading,
    subHeading: props.subHeading,
    optionalText: props.optionalText,
    serverErrorMessaging: {
      errorHeader: props.errorMessage?.heading,
      errorDescription: props.errorMessage?.text,
    },
    privacyRightsHeading: props.privacyHeading,
    privacyRightsText: props.privacyText,
    submitCta: props.submitCta,
    confirmationHeadline: props.submissionConfirmation?.heading,
    confirmationSubline: props.submissionConfirmation?.text,
    backToBrowseCta: props.submissionConfirmation?.closeCta,
  };
};

export class Container extends ResponsiveGrid {
  render() {
    const data = transformData(this.props);

    return (
      <Component {...data}>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        {super.placeholderComponent}
      </Component>
    );
  }
}

const FormBuilder = withComponentMappingContext(Container);
FormBuilder.displayName = 'FormBuilder';

export default withAemIntegration("lexus/components/form-builder/container")(
  FormBuilder,
  FormBuilderContainerEditConfig
);
